import React from 'react';
import ReactionList from './reactionList';
import ReactionHeader from './reactionHeader';


const BLOCK_NAME = 'reactions';

function getTitleElement(title){
  if (!title) {
    return false;
  }
  return (
    <h3 className={ `${ BLOCK_NAME }__title` }>{ title }</h3>
  );
}

export default function ReactionsComponent({
  reactions,
  headerText,
  headerImage,
  selectedReaction,
  onReactionClicked,
  percentages,
  onReactionsListContainerClick,
  title,
}){
  const blockName = BLOCK_NAME;
  const reactionsProps = {
    className: blockName,
    onClick: onReactionsListContainerClick,
  };
  const reactionsHeaderProps = {
    blockName,
    headerText,
    headerImage,
  };
  const reactionsListProps = {
    blockName,
    reactions,
    selectedReaction,
    percentages,
    onReactionClicked,
  };
  return (
    <section { ...reactionsProps }>
      <ReactionHeader { ...reactionsHeaderProps } />
      { getTitleElement(title) }
      <ReactionList { ...reactionsListProps } />
    </section>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/components/reactionsComponent.js